import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/discuss/canvas-send.png';
import _imports_1 from '@/assets/discuss/canvas-send-active.png';
var _hoisted_1 = {
  src: _imports_0,
  alt: ""
};
import { ref, reactive, computed, onMounted, inject } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
import { operationRecord } from '../common';

/* api */
import { addFileAnnocation, addCourseAnnocation, getCanvasDrawId } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'NoteSend',
  props: {
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  emits: ['send'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var userInfo = getStore({
      name: 'userInfo'
    });
    var discussId = inject('discussId');
    var annotationType = inject('annotation-type'); // 在哪个页面批注
    var annotationInfo = inject('annotation-info'); // 页面带来的批注所需信息
    var annotationRoleId = inject('annotation-roleId');
    var emit = __emit;
    var props = __props;
    var textareaRef = ref();
    var state = reactive({
      content: ''
    });

    /* 计算属性 */
    var isEmpty = computed(function () {
      return state.content.length === 0;
    });

    /* 事件 */
    var handleInput = function handleInput(e) {
      state.content = e.target.innerText;
    };

    // 生成批注id
    var getPointId = function getPointId() {
      return new Promise(function (resolve) {
        getCanvasDrawId().then(function (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          }
        });
      });
    };
    var handleSend = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var pointId, data, apiPromise;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (state.content) {
                _context.n = 1;
                break;
              }
              MessagePlugin.warning('请输入内容！');
              return _context.a(2);
            case 1:
              if (!(state.content.length > 300)) {
                _context.n = 2;
                break;
              }
              MessagePlugin.warning('内容最多300字！');
              return _context.a(2);
            case 2:
              _context.n = 3;
              return getPointId();
            case 3:
              pointId = _context.v;
              data = {
                discussId: discussId.value,
                viewerId: annotationRoleId.value,
                pointId: pointId,
                annocationUserId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                annocationName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
                annocationContent: state.content,
                annocationAvatar: userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar
              };
              apiPromise = null;
              if (annotationType === 'file') {
                data.documentId = annotationInfo.value.id;
                data.documentItemId = annotationInfo.value.imgId;
                apiPromise = addFileAnnocation(data);
                operationRecord(discussId.value, '文件—评论');
              } else if (annotationType === 'course') {
                data.courseResearchId = annotationInfo.value.courseId;
                apiPromise = addCourseAnnocation(data);
                operationRecord(discussId.value, '学程—评论');
              }
              apiPromise.then(function (res) {
                if (res.data.code === 0) {
                  MessagePlugin.success('评论成功！');
                  emit('send', pointId);
                }
              });
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleSend() {
        return _ref2.apply(this, arguments);
      };
    }();

    /* 钩子 */
    onMounted(function () {
      textareaRef.value.focus();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["annotation-point", {
          'flex-column': !isEmpty.value
        }]),
        style: _normalizeStyle({
          left: "".concat(props.x, "px"),
          top: "".concat(props.y, "px")
        })
      }, [_createElementVNode("div", {
        ref_key: "textareaRef",
        ref: textareaRef,
        class: "textarea",
        placeholder: "请输入",
        contenteditable: "",
        onInput: handleInput
      }, null, 544), _withDirectives(_createElementVNode("img", _hoisted_1, null, 512), [[_vShow, isEmpty.value]]), _withDirectives(_createElementVNode("img", {
        src: _imports_1,
        alt: "",
        onClick: handleSend
      }, null, 512), [[_vShow, !isEmpty.value]])], 6);
    };
  }
};